import { useWizardContext } from '@shared/hooks'
import { Button } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EditAddAgent } from './EditAddAgent'

type Props = {
  brokerId?: string
}

export const AddAgentButton = ({ brokerId }: Props) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const { refStepThree, onChangeStep, setOpen, current } = useWizardContext()

  const triggerModal = () => {
    setIsOpen((isOpen) => !isOpen)
    setOpen(false)
  }

  const onCancel = () => {
    setIsOpen(false)
    setOpen(true)

    if (current < 5) {
      onChangeStep(3)
    }
  }

  return (
    <>
      <Button
        icon={<Add />}
        type="primary"
        onClick={triggerModal}
        ref={refStepThree}
      >
        {t('add_agent')}
      </Button>

      <EditAddAgent
        brokerId={brokerId}
        open={isOpen}
        onCancel={onCancel}
        onSuccess={triggerModal}
      />
    </>
  )
}
